// localStorage 키 상수
export const STORAGE_KEYS = {
  MEMBERS: 'gym_members',
  MEMBERSHIPS: 'gym_memberships',
  MEMBERSHIP_PRODUCTS: 'gym_membership_products',
  ATTENDANCES: 'gym_attendances',
  PT_PRODUCTS: 'gym_pt_products',
  PT_ASSIGNMENTS: 'gym_pt_assignments',
  PT_LOGS: 'gym_pt_logs',
  TRAINERS: 'gym_trainers',
  LOCKERS: 'gym_lockers',
  SETTINGS: 'gym_settings',
};

export const storage = {
  get: (key) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  },
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  },
  remove: (key) => {
    localStorage.removeItem(key);
  },
};

// 고유 ID 생성
export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
};

// 날짜 헬퍼: 오늘 기준 offset일 후 'yyyy-MM-dd' 문자열
function daysFromNow(offset) {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d.toISOString().split('T')[0];
}

// 초기 샘플 데이터
export const initSampleData = () => {
  if (storage.get(STORAGE_KEYS.MEMBERS)) return; // 이미 데이터 있으면 스킵

  const todayStr = daysFromNow(0);

  const members = [
    {
      id: generateId(),
      name: '김민준',
      gender: 'male',
      birthDate: '1990-05-15',
      phone: '010-1234-5678',
      address: '서울시 강남구 역삼동',
      photo: null,
      purpose: '다이어트',
      referral: '인스타그램',
      memo: '월/수/금 오전 운동',
      status: 'active',
      createdAt: daysFromNow(-20),
    },
    {
      id: generateId(),
      name: '이서연',
      gender: 'female',
      birthDate: '1995-08-22',
      phone: '010-2345-6789',
      address: '서울시 강남구 삼성동',
      photo: null,
      purpose: '체력증진',
      referral: '지인소개',
      memo: '',
      status: 'active',
      createdAt: daysFromNow(-15),
    },
    {
      id: generateId(),
      name: '박지호',
      gender: 'male',
      birthDate: '1988-12-03',
      phone: '010-3456-7890',
      address: '서울시 서초구 방배동',
      photo: null,
      purpose: '근력증가',
      referral: '네이버',
      memo: 'PT 관심 있음',
      status: 'active',
      createdAt: daysFromNow(-28),
    },
    {
      id: generateId(),
      name: '최수아',
      gender: 'female',
      birthDate: '2000-03-20',
      phone: '010-4567-8901',
      address: '서울시 강남구 청담동',
      photo: null,
      purpose: '다이어트',
      referral: '간판',
      memo: '',
      status: 'expired',
      createdAt: daysFromNow(-70),
    },
    {
      id: generateId(),
      name: '정우진',
      gender: 'male',
      birthDate: '1985-07-11',
      phone: '010-5678-9012',
      address: '서울시 송파구 잠실동',
      photo: null,
      purpose: '재활운동',
      referral: '지인소개',
      memo: '무릎 주의',
      status: 'inactive',
      createdAt: daysFromNow(-50),
    },
  ];

  const trainers = [
    {
      id: generateId(),
      name: '강태양',
      phone: '010-1111-2222',
      specialty: '체중감량, 체형교정',
      bio: '경력 7년, NSCA-CPT 자격증 보유',
      createdAt: daysFromNow(-90),
    },
    {
      id: generateId(),
      name: '윤하늘',
      phone: '010-3333-4444',
      specialty: '근력운동, 재활트레이닝',
      bio: '경력 5년, 전직 국가대표 역도선수',
      createdAt: daysFromNow(-90),
    },
  ];

  const membershipProducts = [
    {
      id: generateId(),
      name: '1개월 이용권',
      days: 30,
      price: 88000,
      type: 'period',
    },
    {
      id: generateId(),
      name: '3개월 이용권',
      days: 90,
      price: 240000,
      type: 'period',
    },
    {
      id: generateId(),
      name: '6개월 이용권',
      days: 180,
      price: 420000,
      type: 'period',
    },
    {
      id: generateId(),
      name: '30회 이용권',
      days: 60,
      price: 150000,
      type: 'count',
      totalCount: 30,
    },
  ];

  const ptProducts = [
    {
      id: generateId(),
      name: 'PT 10회',
      sessions: 10,
      price: 500000,
    },
    {
      id: generateId(),
      name: 'PT 20회',
      sessions: 20,
      price: 900000,
    },
    {
      id: generateId(),
      name: 'PT 30회',
      sessions: 30,
      price: 1200000,
    },
  ];

  storage.set(STORAGE_KEYS.MEMBERS, members);
  storage.set(STORAGE_KEYS.TRAINERS, trainers);
  storage.set(STORAGE_KEYS.MEMBERSHIP_PRODUCTS, membershipProducts);
  storage.set(STORAGE_KEYS.PT_PRODUCTS, ptProducts);

  // 샘플 회원권 부여
  const membershipAssignments = [
    {
      id: generateId(),
      memberId: members[0].id,
      productId: membershipProducts[1].id,
      productName: '3개월 이용권',
      startDate: daysFromNow(-20),
      endDate: daysFromNow(70),
      price: 240000,
      status: 'active',
      createdAt: daysFromNow(-20),
    },
    {
      id: generateId(),
      memberId: members[1].id,
      productId: membershipProducts[0].id,
      productName: '1개월 이용권',
      startDate: daysFromNow(-5),
      endDate: daysFromNow(25),
      price: 88000,
      status: 'active',
      createdAt: daysFromNow(-5),
    },
    {
      id: generateId(),
      memberId: members[2].id,
      productId: membershipProducts[0].id,
      productName: '1개월 이용권',
      startDate: daysFromNow(-2),
      endDate: daysFromNow(5),
      price: 88000,
      status: 'active',
      createdAt: daysFromNow(-2),
    },
    {
      id: generateId(),
      memberId: members[3].id,
      productId: membershipProducts[0].id,
      productName: '1개월 이용권',
      startDate: daysFromNow(-70),
      endDate: daysFromNow(-40),
      price: 88000,
      status: 'expired',
      createdAt: daysFromNow(-70),
    },
  ];
  storage.set(STORAGE_KEYS.MEMBERSHIPS, membershipAssignments);

  // 샘플 출석 데이터
  const today = new Date();
  const attendances = [];
  const attendMemberIds = [members[0].id, members[1].id, members[2].id];

  // 오늘 출석
  attendMemberIds.forEach((memberId, i) => {
    attendances.push({
      id: generateId(),
      memberId,
      date: todayStr,
      time: `0${9 + i}:${i * 15 < 10 ? '0' + i * 15 : i * 15}`,
      createdAt: `${todayStr}T0${9 + i}:${i * 15 < 10 ? '0' + i * 15 : i * 15}:00`,
    });
  });

  // 최근 7일 출석
  for (let d = 1; d <= 7; d++) {
    const date = new Date(today);
    date.setDate(date.getDate() - d);
    const dateStr = date.toISOString().split('T')[0];
    const shuffled = attendMemberIds.sort(() => Math.random() - 0.5).slice(0, 2);
    shuffled.forEach((memberId, i) => {
      attendances.push({
        id: generateId(),
        memberId,
        date: dateStr,
        time: `${9 + i}:00`,
        createdAt: `${dateStr}T${9 + i}:00:00`,
      });
    });
  }
  storage.set(STORAGE_KEYS.ATTENDANCES, attendances);

  // 샘플 PT 부여
  const ptAssignments = [
    {
      id: generateId(),
      memberId: members[0].id,
      productId: ptProducts[0].id,
      productName: 'PT 10회',
      trainerId: trainers[0].id,
      trainerName: trainers[0].name,
      totalSessions: 10,
      usedSessions: 3,
      price: 500000,
      status: 'active',
      createdAt: daysFromNow(-20),
    },
    {
      id: generateId(),
      memberId: members[2].id,
      productId: ptProducts[1].id,
      productName: 'PT 20회',
      trainerId: trainers[1].id,
      trainerName: trainers[1].name,
      totalSessions: 20,
      usedSessions: 16,
      price: 900000,
      status: 'active',
      createdAt: daysFromNow(-28),
    },
  ];
  storage.set(STORAGE_KEYS.PT_ASSIGNMENTS, ptAssignments);

  // 샘플 PT 일지
  const ptLogs = [
    {
      id: generateId(),
      ptAssignmentId: ptAssignments[0].id,
      memberId: members[0].id,
      trainerId: trainers[0].id,
      trainerName: trainers[0].name,
      date: daysFromNow(-2),
      content: '스쿼트 3세트, 데드리프트 3세트, 레그프레스 3세트',
      memo: '폼 개선 필요',
      sessionNumber: 3,
    },
    {
      id: generateId(),
      ptAssignmentId: ptAssignments[1].id,
      memberId: members[2].id,
      trainerId: trainers[1].id,
      trainerName: trainers[1].name,
      date: daysFromNow(-1),
      content: '벤치프레스 4세트, 숄더프레스 3세트, 삼두 운동 2세트',
      memo: '무게 증량 성공',
      sessionNumber: 16,
    },
  ];
  storage.set(STORAGE_KEYS.PT_LOGS, ptLogs);

  // 샘플 락커
  const lockers = Array.from({ length: 20 }, (_, i) => ({
    id: generateId(),
    number: i + 1,
    memberId: null,
    memberName: null,
    startDate: null,
    endDate: null,
    status: 'empty',
  }));
  lockers[0].memberId = members[0].id;
  lockers[0].memberName = members[0].name;
  lockers[0].startDate = daysFromNow(-20);
  lockers[0].endDate = daysFromNow(70);
  lockers[0].status = 'occupied';
  lockers[4].memberId = members[1].id;
  lockers[4].memberName = members[1].name;
  lockers[4].startDate = daysFromNow(-5);
  lockers[4].endDate = daysFromNow(25);
  lockers[4].status = 'occupied';
  storage.set(STORAGE_KEYS.LOCKERS, lockers);
};
